module.exports = __webpack_public_path__ + "img/homeimage.e455b330.webp";